import React from 'react'

import Box from '@material-ui/core/Box'
import useForm from 'react-hook-form'

import {
  Button,
  Dialog,
  Divider,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  makeStyles,
  Typography,
} from '@material-ui/core'

import clsx from 'clsx'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { InputCurrency } from 'components/Form'
import { RHFInput } from 'react-hook-form-input'
import useSnackbar from 'hooks/useSnackbar'
import moment from 'moment'

import schemas from '../../../TaxInvoices/schemas'
import styles from './styles'
import * as service from 'service'

const useStyles = makeStyles(styles)

const DialogNFEdit = ({
  invoiceId,
  open,
  setOpen,
  onLoading = () => {},
  onEvent = () => {},
  ...props
}) => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const { handleSubmit, register, setValue, watch, errors } = useForm({
    defaultValues:
      {
        ...props.taxInvoice,
        status: 'issued',
        issuedAt: props.taxInvoice.issuedAt
          ? moment(props.taxInvoice.issuedAt, 'YYYY-MM-DD').toDate()
          : '',
        canceledAt: props.taxInvoice.canceledAt
          ? moment(props.taxInvoice.canceledAt, 'YYYY-MM-DD').toDate()
          : '',
      } || {},
    validationSchema: schemas.editYapay,
  })
  const [taxInvoice, setTaxInvoice] = React.useState(props.taxInvoice)

  React.useEffect(() => {
    register({ name: 'issuedAt' })
    register({ name: 'canceledAt' })
    setTaxInvoice(props.taxInvoice)
  }, [props.taxInvoice, register, taxInvoice.status])

  const onSubmit = async taxInvoice => {
    try {
      onLoading(true)
      await service.recurrence.taxInvoices.attach({
        invoiceId: invoiceId,
        ...taxInvoice,
      })
      onLoading(false)
      onEvent(true)
      Object.keys(taxInvoice).map(key => setValue(key, taxInvoice[key]))
      snackbar.open({
        message: 'Nota Fiscal vinculada com sucesso!',
        variant: 'success',
      })
      setOpen(false)
    } catch (e) {
      onLoading(false)
      snackbar.open({
        message: 'Erro ao vincular Nota Fiscal!',
        variant: 'error',
      })
    }
  }

  const values = watch()

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="new-tax"
    >
      <DialogTitle id="form-dialog-title">
        <div>
          <Typography variant="h3">Editar Nota Fiscal</Typography>
        </div>
      </DialogTitle>
      <DialogContent className={classes.dialog} p={2}>
        <form onSubmit={handleSubmit(onSubmit)} id="taxInvoice-attach-form">
          <Box display="flex">
            <TextField
              label="Número da nota"
              margin="dense"
              name="nfId"
              type="number"
              className={clsx(classes.halfInput, classes.leftInput)}
              inputRef={register}
              error={!!errors.nfId}
              helperText={errors.nfId ? errors.nfId.message : ''}
            />
            <TextField
              label="Código de autenticação"
              margin="dense"
              name="authenticityCode"
              className={classes.halfInput}
              inputRef={register}
              error={!!errors.authenticityCode}
              helperText={
                errors.authenticityCode ? errors.authenticityCode.message : ''
              }
              fullWidth
            />
          </Box>
          <Box display="flex">
            <RHFInput
              as={
                <InputCurrency
                  label="Valor"
                  margin="dense"
                  fullWidth
                  error={!!errors.price}
                  helperText={errors && errors.price && errors.price.message}
                />
              }
              name="amount"
              register={register}
              setValue={setValue}
              className={clsx(classes.halfInput, classes.leftInput)}
              mode="onChange"
            />
            <RHFInput
              as={
                <TextField
                  margin="dense"
                  label="Status"
                  variant="outlined"
                  error={!!errors.status}
                  helperText={errors.status && errors.status.message}
                  SelectProps={{ native: true }}
                  select
                  fullWidth
                >
                  <option value="issued">Emitida</option>
                  <option value="canceled">Cancelado</option>
                </TextField>
              }
              register={register}
              className={classes.halfInput}
              setValue={setValue}
              name="status"
            />
          </Box>
          <TextField
            label="Url da nota"
            margin="dense"
            name="urlInvoice"
            inputRef={register}
            error={!!errors.urlInvoice}
            helperText={errors.urlInvoice ? errors.urlInvoice.message : ''}
            fullWidth
          />
          <Box display="flex" justifyContent="around">
            <KeyboardDatePicker
              margin="dense"
              label="Data de emissão"
              format="dd/MM/yyyy"
              name="issuedAt"
              className={clsx(classes.halfInput, classes.leftInput)}
              error={!!errors.issuedAt}
              helperText={errors.issuedAt ? errors.issuedAt.message : ''}
              onChange={e => setValue('issuedAt', e)}
              value={values.issuedAt || null}
            ></KeyboardDatePicker>
            {values.status === 'canceled' && (
              <KeyboardDatePicker
                margin="dense"
                label="Data de cancelamento"
                format="dd/MM/yyyy"
                name="canceledAt"
                className={classes.halfInput}
                error={!!errors.canceledAt}
                helperText={errors.canceledAt ? errors.canceledAt.message : ''}
                onChange={e => setValue('canceledAt', e)}
                value={values.canceledAt || null}
              ></KeyboardDatePicker>
            )}
          </Box>
          {values.status === 'canceled' && (
            <TextField
              label="Motivo de cancelamento"
              margin="dense"
              name="reason"
              inputRef={register}
              error={!!errors.reason}
              helperText={errors.reason ? errors.reason.message : ''}
              fullWidth
            />
          )}
        </form>
      </DialogContent>
      <Divider />
      <DialogActions p={2}>
        <Button
          color="primary"
          variant="contained"
          type="submit"
          form="taxInvoice-attach-form"
          className={classes.button}
        >
          Salvar
        </Button>
        <Button
          onClick={() => setOpen(false)}
          color="primary"
          variant="outlined"
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogNFEdit
